// extracted by mini-css-extract-plugin
export default {"buttonSecondary":"T3Q4NodtO9SKxtogNzJ3","buttonTertiary":"QfIM91HPu1mzbAE61NAD","content":"bCw_5Df0xpd_R8do2aHQ"};